module.exports = __webpack_public_path__ + "static/media/the-catfather.4fd89611.gif";